import React from 'react';
import { Container, Card, CardImg, CardTitle, Breadcrumb, CardFooter } from 'reactstrap';
import { Col, Row } from 'antd';
import { useHistory } from 'react-router';

const json = [
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit Starter',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 1: Towns and cities',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 2: Days',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 3: Wild life',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 4: Learning world',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 5: Food and Health',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 6: Sport',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 7: Growing up',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/online-test-concept-quiz-computer_277904-3537.jpg',
    title: 'Unit 8: Going away',
  },
];

export default function SampleTest() {
  const history = useHistory();

  const renderList = React.useMemo(() => {
    return json.map((item, index) => {
      const url = `/lms/sampleTest/${index}/Units`;
      return (
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={6} key={index} className='mt-2'>
          <Card key={index} style={{ cursor: 'pointer' }} onClick={() => history.push(url)}>
            <CardImg alt='...' src={item.imgUrl} top />
            <CardFooter>
              <CardTitle style={{ fontWeight: 600, fontSize: 20 }}>{item.title}</CardTitle>
            </CardFooter>
          </Card>
        </Col>
      );
    });
  }, [history]);
  return (
    <>
      <div className='header bg-info pb-6'>
        <Container fluid>
          <div className='header-body'>
            <Row className='align-items-center py-4'>
              <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <h6 className='h2 text-white d-inline-block mb-0'>
                  <span style={{ cursor: 'pointer' }} onClick={() => history.push('/lms/sampleTests')}>
                    Sample Test
                  </span>
                </h6>{' '}
                <Breadcrumb className='d-none d-md-inline-block ml-md-4' listClassName='breadcrumb-links breadcrumb-dark'></Breadcrumb>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container fluid className='mt--6'>
        <Row gutter={[16, 0]}>{renderList}</Row>
      </Container>
    </>
  );
}
